import React from 'react';
import { useSlideData } from '@context/slide-data';
import { SectionOne } from './SectionOne';
import { SectionTwo } from './SectionTwo';

export const WeCanHelpScript = () => {
    const { slideState, data } = useSlideData();
    const { selectedSection } = slideState;

    const sections = {
        1: <SectionOne />,
        2: <SectionTwo />,
    }

    return sections[selectedSection[data.id]];
};

export default WeCanHelpScript;
